import * as React from "react";
import Tooltip from "@mui/material/Tooltip";
import Table from "@mui/material/Table";
import Box from "@mui/material/Box";
import { Chip } from "@mui/material";
import IconButton from "@mui/material/IconButton";
import Typography from "@mui/material/Typography";
import { useTheme as useAppTheme } from '../../contexts/ThemeContext';
import { styled } from "@mui/material/styles";
import TableBody from "@mui/material/TableBody";
import TableCell, { tableCellClasses } from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import { useState, useEffect } from "react";
import ShoppingCartIcon from '@mui/icons-material/ShoppingCart';
import {
  Button,
  TextField,
  Paper,
  TablePagination,
} from "@mui/material";
import CircularProgress from "@mui/material/CircularProgress";
import RefreshIcon from "@mui/icons-material/Refresh";
import {
  retrieveCheckindata,
  Manualcheckout,
  StoreBiometric,
} from "../Apihelper/AttendanceHelper";
import { useNavigate } from "react-router-dom";
import AppToast from '../../components/Toast/AppToast';

const StyledTableCell = styled(TableCell)(({ theme }) => ({
  [`&.${tableCellClasses.head}`]: {
    backgroundColor: theme.palette.primary.main,
    color: theme.palette.common.white,
    fontWeight: 'bold',
    borderBottom: 'none',
  },
  [`&.${tableCellClasses.body}`]: {
    fontSize: 14,
  },
}));

const StyledTableRow = styled(TableRow)(({ theme }) => ({
  '&:nth-of-type(odd)': {
    backgroundColor: '#f9f9f9',
  },
  '&:hover': {
    backgroundColor: 'rgba(31, 122, 84, 0.08)',
    cursor: 'pointer',
  },
}));

function AttendanceNonRegister(props) {
  const { colors: appColors } = useAppTheme();
  const navigate = useNavigate();
  const { onTotalChange } = props;
  const [openToast, setOpenToast] = useState(false);
  const [fetchdatarow, setetchdatarow] = useState([]);
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [totalCount, setTotalCount] = useState(0);
  const [loading, setLoading] = useState(false);
  const [searchText, setSearchText] = useState("");
  const [snackbarMessage, setSnackbarMessage] = useState("");
  const [snackbarSeverity, setSnackbarSeverity] = useState("success");

  const handleToastClose = () => {
    setOpenToast(false);
  };
  const handleSnackbarOpen = (message, severity) => {
    setSnackbarMessage(message);
    setSnackbarSeverity(severity);
    setOpenToast(true);
  };

  const fetchData = async (value = "", newPage = 0, newRowsPerPage = 10) => {
    setLoading(true);
    try {
      const userData = localStorage.getItem("userdata");
      const userDataObj = JSON.parse(userData);
      const userToken = userDataObj.token;
      const limit = newRowsPerPage;
      const index = newPage * newRowsPerPage;

      const res = await retrieveCheckindata(
        userToken,
        "",
        "nonregister",
        value,
        limit,
        index
      );

      if (res.code === 200) {
        if (res.data && res.data.length > 0) {
          setetchdatarow(res.data);
        } else {
          setetchdatarow([]);
          handleSnackbarOpen("No Record Found", "warning");
        }
        const count = res.total_count ?? 0;
        setTotalCount(count);
        if (onTotalChange) onTotalChange(count);
      }
    } catch (error) {
      console.error(error);
      handleSnackbarOpen("Something went wrong", "error");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchData("", page, rowsPerPage);
  }, []);

  React.useEffect(() => {
    const storedData = localStorage.getItem("userdata");
    if (!storedData) {
      navigate('/');
    }
  }, []);

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
    fetchData(searchText, newPage, rowsPerPage);
  };

  const handleChangeRowsPerPage = (event) => {
    const newRowsPerPage = parseInt(event.target.value, 10);
    setRowsPerPage(newRowsPerPage);
    setPage(0);
    fetchData(searchText, 0, newRowsPerPage);
  };

  const handleSearchChange = (event) => {
    const value = event.target.value;
    setSearchText(value);
    setPage(0);
    fetchData(value, 0, rowsPerPage);
  };

  const handleCheckout = async (id) => {
    try {
      const userData = localStorage.getItem("userdata");
      const userDataObj = JSON.parse(userData);
      const userToken = userDataObj.token;

      const response = await Manualcheckout(userToken, id);
      if (response.code == "200") {
        handleSnackbarOpen(response.message, "success");
        fetchData(searchText, page, rowsPerPage);
      } else {
        handleSnackbarOpen(response.message, "error");
      }
    } catch (error) {
      console.error("Checkout Error:", error.message);
    }
  };

  const handleRefresh = async () => {
    try {
      const userData = localStorage.getItem("userdata");
      const userDataObj = JSON.parse(userData);
      const userToken = userDataObj.token;

      const response = await StoreBiometric(userToken);
      if (response.code == "200") {
        handleSnackbarOpen(response.message, "success");
        fetchData(searchText, page, rowsPerPage);
      } else {
        handleSnackbarOpen(response.message, "error");
      }
    } catch (error) {
      console.error("Checkout Error:", error.message);
    }
  };

  return (
    <Box sx={{
      width: '100%',
      p: { xs: 1, sm: 2, md: 3 },
    }}>
      {/* Header Section */}
      <Box sx={{
        display: 'flex',
        flexDirection: { xs: 'column', sm: 'row' },
        justifyContent: 'space-between',
        alignItems: { xs: 'stretch', sm: 'center' },
        gap: 2,
        mb: 2
      }}>
        <Typography variant="h5" sx={{ fontWeight: 600, color: appColors.leaf }}>
          Non-Register Members
        </Typography>
        <Button
          variant="contained"
          onClick={handleRefresh}
          startIcon={<RefreshIcon />}
          fullWidth={true}
          sx={{
            bgcolor: appColors.leaf,
            '&:hover': { bgcolor: appColors.pine },
            maxWidth: { sm: '200px' }
          }}
        >
          Refresh
        </Button>
      </Box>

      {/* Search Section */}
      <Box sx={{ mb: 3 }}>
        <TextField
          placeholder="Search Non-Register Members"
          size="small"
          fullWidth
          value={searchText}
          onChange={handleSearchChange}
          sx={{
            width: { xs: '100%', sm: '300px' },
            '& .MuiOutlinedInput-root': {
              bgcolor: 'white',
            }
          }}
        />
      </Box>

      {/* Table Section */}
      <Box sx={{
        width: '100%',
        overflowX: 'auto',
        mb: 3,
        '& .MuiTableContainer-root': {
          borderRadius: 1,
        }
      }}>
        <TableContainer component={Paper}>
          {loading ? (
            <Box sx={{ textAlign: 'center', p: 4 }}>
              <CircularProgress sx={{ color: appColors.leaf }} />
            </Box>
          ) : (
            <Table sx={{ minWidth: 800 }}>
              <TableHead>
                <TableRow>
                  <StyledTableCell>S.NO</StyledTableCell>
                  <StyledTableCell>NAME / ID</StyledTableCell>
                  <StyledTableCell>DATE</StyledTableCell>
                  <StyledTableCell>CHECK IN</StyledTableCell>
                  <StyledTableCell>CHECK OUT</StyledTableCell>
                  <StyledTableCell>PHONE</StyledTableCell>
                  <StyledTableCell>STATUS</StyledTableCell>
                  <StyledTableCell>WORK HOURS</StyledTableCell>
                  <StyledTableCell>ACTION</StyledTableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {fetchdatarow.map((row, indexx) => (
                  <StyledTableRow key={indexx}>
                    <TableCell sx={{ whiteSpace: 'nowrap' }}>{page * rowsPerPage + indexx + 1}</TableCell>
                    <TableCell sx={{ whiteSpace: 'nowrap' }}>
                      {row.user_name}
                      <Box component="span" sx={{ display: 'block', fontSize: '0.75rem', color: 'text.secondary' }}>
                        {row.user_id}
                      </Box>
                    </TableCell>
                    <TableCell sx={{ whiteSpace: 'nowrap' }}>{row.date}</TableCell>
                    <TableCell sx={{ whiteSpace: 'nowrap' }}>{row.check_in}</TableCell>
                    <TableCell sx={{ whiteSpace: 'nowrap' }}>{row.check_out}</TableCell>
                    <TableCell sx={{ whiteSpace: 'nowrap' }}>{row.phone}</TableCell>
                    <TableCell sx={{ whiteSpace: 'nowrap' }}>
                      <Chip
                        label={row.status}
                        size="small"
                        sx={{
                          bgcolor: row.status === 'active'
                            ? 'rgba(16, 185, 129, 0.1)'
                            : 'rgba(239, 68, 68, 0.1)',
                          color: row.status === 'active'
                            ? '#10b981'
                            : '#ef4444',
                          fontWeight: 500,
                        }}
                      />
                    </TableCell>
                    <TableCell sx={{ whiteSpace: 'nowrap' }}>{row.work_hours}</TableCell>
                    <TableCell sx={{ whiteSpace: 'nowrap' }}>
                      <Tooltip title="Checkout">
                        <IconButton
                          onClick={() => handleCheckout(row.id)}
                          size="small"
                          sx={{
                            color: appColors.leaf,
                            '&:hover': {
                              bgcolor: 'rgba(31, 122, 84, 0.08)',
                            },
                          }}
                        >
                          <ShoppingCartIcon />
                        </IconButton>
                      </Tooltip>
                    </TableCell>
                  </StyledTableRow>
                ))}
              </TableBody>
            </Table>
          )}
        </TableContainer>
      </Box>

      {/* Pagination */}
      <TablePagination
        component="div"
        count={totalCount}
        page={page}
        onPageChange={handleChangePage}
        rowsPerPage={rowsPerPage}
        rowsPerPageOptions={[10, 20, 50]}
        onRowsPerPageChange={handleChangeRowsPerPage}
        showFirstButton
        showLastButton
        sx={{ '& .MuiTablePagination-toolbar': { flexWrap: 'wrap', justifyContent: 'center', px: { xs: 1, sm: 2 } }, '& .MuiTablePagination-actions': { mr: { xs: 0, sm: 8 } } }}
        labelDisplayedRows={({ page: p, count }) =>
          `Page ${p + 1} of ${Math.ceil(count / rowsPerPage)}  |  Total: ${count} records`
        }
      />

      <AppToast open={openToast} message={snackbarMessage} severity={snackbarSeverity} onClose={handleToastClose} />
    </Box>
  );
}

export default AttendanceNonRegister;
